function docReady(fn) {
    // see if DOM is already available
    if (document.readyState === "complete" || document.readyState === "interactive") {
        // call on next available tick
        setTimeout(fn, 1);
    } else {
        document.addEventListener("DOMContentLoaded", fn);
    }
}    


function tarjetasEnBlanco() {
  /* Evita un bug del theme poniendo las últimas tarjetas
  de las categorías en fondo blanco y texto en negro */

  const searchText = "Ver tudo";
  const elements =  document.getElementsByClassName("productgrid--item");
  for (const elem of elements){
    if(elem.innerHTML.indexOf(searchText) !== -1 ){
      elem.style.color = "black";
      const links = elem.getElementsByClassName("featured-collection--title-card--outer");
      if(links.length>0){
      	links[0].style.backgroundColor = "white";
      }
    }
  }
}

docReady(function() {
    tarjetasEnBlanco();
});